// src/services/paymentDetailService.js
import api from 'services/api';

export const paymentDetailService = {
  // === Vendor endpoints ===

  // Get all payment details for the authenticated vendor
  getPaymentDetails: async () => {
    const response = await api.get('/vendor/payment-details');
    return response.data;
  },

  // Create a new payment detail record
  createPaymentDetail: async (data) => {
    const response = await api.post('/vendor/payment-details', data);
    return response.data;
  },

  // Update an existing payment detail record
  updatePaymentDetail: async (id, data) => {
    const response = await api.put(`/vendor/payment-details/${id}`, data);
    return response.data;
  },

  // Request deactivation of an approved bank account
  requestDeactivation: async (id) => {
    const response = await api.post(`/vendor/payment-details/${id}/request-deactivation`);
    return response.data;
  },

  // === Admin endpoints ===

  // Get all vendor payment details (admin)
  getAll: async (params = {}) => {
    const response = await api.get('/admin/vendor-payment-details', { params });
    return response.data;
  },

  // Get bank account approval statistics (admin)
  getStatistics: async () => {
    const response = await api.get('/admin/vendor-payment-details/statistics');
    return response.data;
  },

  // Get a specific payment detail (admin)
  getById: async (id) => {
    const response = await api.get(`/admin/vendor-payment-details/${id}`);
    return response.data;
  },

  // Approve a bank account (admin)
  approve: async (id) => {
    const response = await api.post(`/admin/vendor-payment-details/${id}/approve`);
    return response.data;
  },

  // Reject a bank account (admin)
  reject: async (id, reason) => {
    const response = await api.post(`/admin/vendor-payment-details/${id}/reject`, { reason });
    return response.data;
  },

  // Deactivate an approved bank account (admin)
  deactivate: async (id) => {
    const response = await api.post(`/admin/vendor-payment-details/${id}/deactivate`);
    return response.data;
  }
};

export default paymentDetailService;
